"use client";
import { useMediaQuery } from "@mui/material";

export const useWcMediaQuery = (query: string) => useMediaQuery(query);
